(function() {
  $.fn.toggleFormSection = function(display) {
    this.find('input').addBack('input').prop('disabled', !(!!display));
    this.toggle(!!display);
  }
}());
